<template>
    <div class="main">
        <van-nav-bar title="交存详情" left-arrow @click-left="onClickLeft" />
        <template v-if="!firstFlag">
            <div id="captureId">
                <div class="info">
                    <h3 style="margin-top:0">收款账户信息</h3>
                    <p>账户名称：<span class="introduce">键为县住房和城乡建设局</span></p>
                    <p>账&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号：<span class="introduce">2237 1101 0400 2076 7</span>
                    </p>
                    <p>开&nbsp;&nbsp;户&nbsp;行：<span class="introduce">中国农业银行股份有限公司键为县支行</span></p>


                </div>
                <div class="pay">
                    <div class="title">
                        <h3 style="margin:10px 0 10px 0">付款码</h3>
                        <div style="color:#4E4D4D;">请先保存付款码至相册后，使用微信扫码选择该图片完成付款。</div>
                    </div>
                    <div class="code">
                        <div style="width:180px;height:180px ; border-radius: 8px; border: 1px solid #E4E4E4;padding: 10px;"
                            ref="qrCodeUrl">
                        </div>
                        <div class="total">
                            <div>应交金额</div>
                            <div style="color:#FF3566;margin-top: 10px;font-size: 18px;font-weight: 600;">￥{{ money }}
                            </div>


                        </div>
                    </div>

                    <div class="action">
                        <!-- <div class="cancel" @click="cancel">取消</div> -->
                        <div style="color:#4E4D4D;margin-bottom: 10px;">长按付款码，保存至本地相册</div>
                    </div>
                </div>
            </div>

        </template>

        <img :src="dataURL" alt="" v-show="firstFlag" style="width: 100%; height: 100%" />
    </div>
</template>

<script>
import QRCode from 'qrcodejs2'
import pay from '@/api/pay.js'
import html2canvas from "html2canvas";
export default {
    name: '',
    components: {

    },
    data() {
        return {
            money: '',
            tzdId: '',
            url: '',
            firstFlag: false,
            dataURL: ''
        }
    },
    created() {

    },
    mounted() {
        this.tzdId = this.$route.query.id
        this.money = this.$route.query.total
        this.url = sessionStorage.getItem('payUrl')
        setTimeout(() => {
            this.creatQrCode()
        }, 200);

    },
    methods: {
        onClickLeft() {
            // window.history.go(-1)
            location.href = 'saveDetail' + '?id=' + this.tzdId
        },
        creatQrCode() {
            var qrcode = new QRCode(this.$refs.qrCodeUrl, {
                text: this.url, // 需要转换为二维码的内容
                width: 160,
                height: 160,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            })
            this.savePic()
        },

        transImg(Url) {
            Url = this.dialogImgUrl //图片路径，也可以传值进来
            var triggerEvent = "touchstart"; //指定下载方式
            var blob = new Blob([''], { type: 'application/octet-stream' }); //二进制大型对象blob
            var url = URL.createObjectURL(blob); //创建一个字符串路径空位
            var a = document.createElement('a'); //创建一个 a 标签
            a.href = Url;  //把路径赋到a标签的href上
            //正则表达式，这里是把图片文件名分离出来。拿到文件名赋到a.download,作为文件名来使用文本
            a.download = Url.replace(/(.*\/)*([^.]+.*)/ig, "$2").split("?")[0];

            var e = new MouseEvent('click', (true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null));
            //派遣后，它将不再执行任何操作。执行保存到本地
            a.dispatchEvent(e);
            //释放一个已经存在的路径（有创建createObjectURL就要释放revokeObjectURL）
            URL.revokeObjectURL(url);

        },

        //保存图片至手机
        savePic() {
            html2canvas(document.querySelector("#captureId")).then((canvas) => {
                let imgUrl = canvas.toDataURL("image/png");
                this.dataURL = imgUrl;
                console.log('===', this.dataURL)
                this.firstFlag = true;
                this.transImg(this.dataURL)
            });
        },



        cancel() {
            location.href = 'saveDetail' + '?id=' + this.tzdId
        }
    }
}
</script>

<style lang="less" scoped>
.main {
    min-height: 100vh;
    display: flex;
    flex-direction: column;

    .info {
        width: 100%;
        height: 220px;
        background: url(../../assets/img/fukuan_bg_img@3x.png) no-repeat;
        background-size: cover;
        padding: 20px 0 20px 20px;
    }

    .introduce {
        font-size: 16px;
        font-weight: 550;
    }

    .pay {
        flex: 1;
        border-radius: 20px;
        position: relative;


    }

    .title {
        padding: 40px;
        padding-top: 10px;
        text-align: center;
    }

    .code {

        width: 180px;
        height: 230px;
        position: relative;
        left: 50%;
        top: 80px;
        transform: translate(-50%, -50%);
        padding: 10px;
    }

    .action {
        display: flex;
        text-align: center;
        justify-content: center;
        align-items: center;

        .cancel {
            background-color: #dcdcdc;
            line-height: 40px;
            width: 100px;
            height: 40px;
            border-radius: 23px;
            margin-right: 20px;
            color: #3f3f3f;
        }

        .save {
            width: 140px;
            height: 40px;
            line-height: 40px;
            color: #fff;
            background-color: #FF6C1A;
            border-radius: 23px;
        }
    }

    .total {
        height: 60px;
        margin-top: 10px;
        text-align: center;
    }

}
</style>
